import { queryClient } from '@/src/lib/react-query/react-query';

import { inboxEntriesKeys } from './getInboxEntries';

import { updateFilterStatusCounters } from '../../../api/getFilterCounters';
import { StatusFilterEnum } from '../../../types';
import { fileDetailsKeys } from '../../EntryPanel/FileEntryViewer/api/getFileDetails';

export const updateSidebarInboxEntry = ({
  projectId,
  newInboxEntry,
  filter = null,
  shoulldUpdateStatusCounters = false,
}: {
  projectId: string;
  filter?: StatusFilterEnum;
  newInboxEntry: any; // newInboxEntry must be raw response
  shoulldUpdateStatusCounters?: boolean;
}) => {
  let isThreadStatusChanged = false;

  queryClient.setQueriesData([...inboxEntriesKeys.lists({ projectId, filter })], (prev: any) => {
    return {
      ...prev,
      pages: prev.pages?.map((page) => {
        return {
          ...page,
          data: page.data?.map((inboxEntry) => {
            if (inboxEntry['source-id'] === newInboxEntry['source-id']) {
              isThreadStatusChanged = inboxEntry.status !== newInboxEntry.status;
              return newInboxEntry;
            }
            return inboxEntry;
          }),
        };
      }),
    };
  });

  if (shoulldUpdateStatusCounters && isThreadStatusChanged) {
    updateFilterStatusCounters({ projectId, newStatus: newInboxEntry.status });
  }
};

// Adds on top of the list
export const addSidebarInboxFileEntry = ({ projectId, newInboxEntry, newFileEntry, filter }) => {
  // Update sidebarlist with uploaded file entry
  queryClient.setQueriesData([...inboxEntriesKeys.lists({ projectId, filter })], (prev: any) => {
    return {
      ...prev,
      pages: prev.pages?.map((page, index) => {
        if (index === 0) {
          return {
            ...page,
            data: [newInboxEntry, ...page.data],
          };
        }
        return page;
      }),
    };
  });

  if (newFileEntry) {
    // Prefill uploaded file entry
    queryClient.setQueryData(
      [...fileDetailsKeys.detail({ fileId: newInboxEntry.id })],
      (prev: any) => {
        return {
          ...prev,
          data: newInboxEntry,
        };
      }
    );
  }
};
